"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var components_1 = require("@wordpress/components");
var icons_1 = require("@wordpress/icons");
var element_1 = require("@wordpress/element");
var block_editor_1 = require("@wordpress/block-editor");
var types_1 = require("@/types");
var globals_1 = require("./globals");
var cogicon_svg_1 = require("@/../cogicon.svg");
var select_dialog_1 = require("@/components/select-dialog");
var preview_form_1 = require("@/components/preview-form");
var Edit = function (_a) {
    var attributes = _a.attributes, setAttributes = _a.setAttributes, className = _a.className;
    var _b = (0, element_1.useState)(false), selectDialogOpen = _b[0], setSelectDialogOpen = _b[1];
    var handleForm = function (form) {
        setAttributes({
            orgId: form.orgId,
            formId: form.formId,
            seamlessEmbedCode: form.embedCodes.Seamless,
            iframeEmbedCode: form.embedCodes.IFrame,
            ampEmbedCode: form.embedCodes.Amp,
            embedMode: types_1.EmbedMode.Seamless,
        });
    };
    return (React.createElement("div", { className: className },
        attributes.formId ?
            // A form has already been selected, so render the form preview.
            React.createElement("div", null,
                React.createElement(block_editor_1.BlockControls, null,
                    React.createElement(components_1.ToolbarButton, { icon: icons_1.edit, label: "Edit", onClick: function () { return setSelectDialogOpen(true); } })),
                React.createElement(block_editor_1.InspectorControls, { key: "setting" },
                    React.createElement(components_1.PanelBody, { title: "Form Settings" },
                        React.createElement(components_1.PanelRow, null,
                            React.createElement(components_1.RadioControl, { label: "Embed Mode", help: React.createElement("span", null,
                                    "The type of embed code to use with your form. ",
                                    React.createElement(components_1.ExternalLink, { href: "https://www.cognitoforms.com/support/10/style-publish" }, "Learn more")), selected: attributes.embedMode, options: [
                                    { label: 'Seamless', value: types_1.EmbedMode.Seamless },
                                    { label: 'Iframe', value: types_1.EmbedMode.IFrame },
                                ], onChange: function (value) { return setAttributes({ embedMode: parseInt(value.toString()) }); } })))),
                React.createElement(preview_form_1.default, { embedCode: attributes.iframeEmbedCode }))
            :
                // No form has been selected yet, so render the placeholder.
                React.createElement("div", null,
                    React.createElement(components_1.Placeholder, { icon: cogicon_svg_1.ReactComponent, label: "Cognito Forms", instructions: "Choose an existing form to embed or create a new one." },
                        React.createElement("div", { style: { display: 'flex' } },
                            React.createElement(components_1.Button, { variant: "primary", onClick: function () { return setSelectDialogOpen(true); } }, "Select Form"),
                            React.createElement(components_1.Button, { href: "".concat(globals_1.baseUrl, "/forms/new"), target: "_blank", icon: icons_1.external, iconPosition: "right", iconSize: 16, variant: "secondary" }, "New Form")))),
        selectDialogOpen &&
            // Selectively render the select dialog
            React.createElement(select_dialog_1.default, { setOpen: function (val) { return setSelectDialogOpen(val); }, onSelectForm: handleForm })));
};
exports.default = Edit;
